<!-- 原來的文本标签 -->
<!--<template>-->
    <!--<div class="label-design" :style="{'display':'flex','justify-content':component.properties.justifyContent,'align-items':component.properties.alignItems,'font-weight':component.properties.fontWeight,'color':component.properties.color,'height':height}">-->
     <!--{{component.name}}-->
    <!--</div>-->
<!--</template>-->

<!--<script>-->
<!--import { componentMixin } from '../mixins'-->
<!--import { heightMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'-->
<!--export default {-->
  <!--name: 'rc-label',-->
  <!--props: ['initComponent'],-->
  <!--mixins: [ componentMixin, heightMixin ],-->
  <!--data () {-->
    <!--return {-->
      <!--component: this.initComponent-->
    <!--}-->
  <!--}-->
<!--}-->
<!--</script>-->

<!--<style lang="scss">-->
<!--.label-design{-->
  <!--overflow-y: auto;-->
  <!--width: 100%;-->
  <!--height: 100%;-->
  <!--white-space: nowrap;-->
  <!--overflow: hidden;-->
<!--}-->
<!--</style>-->
<template>
  <div class="rc-label-design">
    <label class="item-name">{{component.name}}</label>
    <div class="component-content">
      <div class="editor" ref="editor"></div>
      <div class="model"></div>
    </div>
  </div>
</template>

<script>
import Editor from 'wangeditor'
import { componentMixin } from '../mixins'
export default {
  name: 'rc-label',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent,
      editor: null
    }
  },
  mounted () {
    this.editor = new Editor(this.$refs.editor)
    this.editor.customConfig.zIndex = 100
    this.editor.customConfig.showLinkImg = false
    // 设计页先用base64
    this.editor.customConfig.uploadImgShowBase64 = true
    this.editor.create()
    this.editor.$textElem.attr('contenteditable', false)
    this.$nextTick(this.component.properties.labelContent && this.editor.txt.html(this.component.properties.labelContent))
  },
  watch: {
    'component.properties.labelContent' (val) {
      this.editor.txt.html(val)
    }
  }
}
</script>
<style lang="scss">
  .rc-label-design {
    .component-content {
      position: relative;
      .editor {
        .w-e-toolbar {
          // 隐藏 富文本的标题
          display: none !important;
        }
        .w-e-text-container {
          border-top: 1px solid #ccc !important;
          -webkit-border-radius: 4px;
          -moz-border-radius: 4px;
          border-radius: 4px;
          // 修改 style属性的值
          height: auto!important;
          min-height: 28px!important;
        }
      }
      .model {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        background: transparent;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/label/rc-label.vue